// Guard: attach the delegated click handler once (it already catches current + future .bulk-buy labels); rebindBulkBuyEvents() was called 3x on load, stacking duplicate handlers that all fired on every click.
let bulkBuyEventsBound = false;
function rebindBulkBuyEvents() {
  if (bulkBuyEventsBound) return;
  bulkBuyEventsBound = true;
  document.addEventListener('click', function (event) {
    // Check if the clicked element (or one of its ancestors) matches 'label.bulk-buy'
    const label = event.target.closest('label.bulk-buy');
    if (!label) return;
    const qty = label.getAttribute('data-qty');
    if (typeof window.updatePriceDisplay === 'function') {
      window.updatePriceDisplay(qty);
    }
    // Grab at box follows the pack too, otherwise it keeps showing the 1 pack offer price.
    if (typeof window.updateMegaSalePrice === 'function') {
      window.updateMegaSalePrice(qty);
    }
  });
}

window.updatePriceDisplay = function(Value) {
    if (isNaN(Value) || Value <= 0) {
        console.warn('Invalid quantity:', Value);
        return;
    }

    // The sticky bar carries the multipack %; a quick view on a collection page has no sticky
    // bar, so fall back to the bulk tiles' wrapper, which carries the same three values.
    const mainAddToBasketContainer = document.querySelector('.main-add-to-basket') || document.querySelector('.main-bulk-buy');
    const priceSections = document.querySelectorAll('.price_quantity_wrapper .price__container, product-info .price__container, .main-add-to-basket .price__container');

    // 1st item discount from theme settings, 0 means quantity 1 keeps the normal product price
    const discountOne = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-one')) || 0 : 0;
    const discountTwo = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-two')) || 0 : 0;
    const discountThree = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-three')) || 0 : 0;

    const updateQuantityInputs = (Value) => {
        document.querySelectorAll('.price_quantity_wrapper .quantity__input').forEach(input => input.value = Value);
        document.querySelectorAll('.updated-product-quantity').forEach(input => input.setAttribute("value", Value));
        document.querySelectorAll('.price-per-item__container .quantity__button').forEach(button => {
           if (Value >= 2) {
            button.classList.remove('disabled');
          }
        });
    };

    // Takes the single-bottle price, not the line total: the discount comes off each bottle, see applyUnitPennyDiscount
    const getDiscountedPrice = (unitPrice, Value) => {
        if (Value == 1) return applyUnitPennyDiscount(unitPrice, Value, discountOne);
        if (Value > 1 && Value < 3) return applyUnitPennyDiscount(unitPrice, Value, discountTwo);
        if (Value > 2) return applyUnitPennyDiscount(unitPrice, Value, discountThree);
        return unitPrice * Value;
    };

    // Hoisted out of the price loop below: it used to run once per price container, so it
    // was skipped entirely whenever none matched and the cart got the stale quantity.
    updateQuantityInputs(Value);

    const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
    const bulkBuy = document.querySelector('.main-bulk-buy');
    if (checkedInput && !bulkBuy) {
      let productWrapper = checkedInput.closest(".product__info-wrapper"); 
      let priceContainer = productWrapper.querySelector(".price__container");
      let selectedVariantPrice = parseFloat(checkedInput.getAttribute("product-option-variant-price")) / 100;
      let selectedVariantMrp = parseFloat(checkedInput.getAttribute("product-option-variant-mrp")) / 100;
      // alert(priceContainer.value);
      if (selectedVariantPrice && selectedVariantMrp > selectedVariantPrice) {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>
        <s class="price-item price-item--compare price-item--regular">${formatPrice(selectedVariantMrp * Value)}</s>`
      } else {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>`  
      }

      const totalRegularPrice = getProductPriceBasedOnQuantity(Value, selectedVariantPrice);
      updatePerServingPrice(priceContainer, totalRegularPrice, Value);
      // Update comfort points based on discounted or regular price
      updateCustomerPoints(Value, totalRegularPrice, totalRegularPrice);
    } else {

      priceSections.forEach(priceContainer => {
        const regularPrice = parseFloat(priceContainer.getAttribute('data-regular-price')) / 100;
        const compareAtPrice = parseFloat(priceContainer.getAttribute('data-compare-price')) / 100;

        const hasBulkDiscount = mainAddToBasketContainer && (
          mainAddToBasketContainer.hasAttribute('data-discount-one') ||
          mainAddToBasketContainer.hasAttribute('data-discount-two') ||
          mainAddToBasketContainer.hasAttribute('data-discount-three')
        );

        // Retrieve the stored flag from sessionStorage
        const xvdStored = sessionStorage.getItem('xvd_found');

        let isBulkApplicable;
        if (xvdStored === 'true') {
          // xvd was detected earlier in the session
          isBulkApplicable = false;
        } else {
          // Normal bulk logic
          isBulkApplicable = Value > 1 && hasBulkDiscount;
        }

        const totalRegularPrice = getProductPriceBasedOnQuantity(Value, regularPrice);
        let totalCompareAtPrice;
        if (isBulkApplicable) {
            // When bulk discount is applied, compare-at = base price * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, regularPrice) : null;
        } else {
            // Else, use actual compare-at * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, compareAtPrice) : null;
        }

        // Quantity 1 is discounted only when a 1st item discount is set and bulk pricing is not suppressed for this session
        const isFirstItemDiscountApplicable = Value == 1 && discountOne > 0 && hasBulkDiscount && xvdStored !== 'true';

        let finalPrice = totalRegularPrice;
        if (isBulkApplicable || isFirstItemDiscountApplicable) {
            finalPrice = getDiscountedPrice(regularPrice, Value);
        }

        // Published for <subscription-options>, which prices the sticky buy bar from the
        // one-time total for whatever quantity that bar is on. In pence, and always the
        // figure rendered as the sale price below - every branch either shows finalPrice or
        // a value it is equal to. Keeping the multipack discount rules here, in one place,
        // rather than having the subscription card work them out a second time.
        priceContainer.dataset.onceTotal = String(Math.round(finalPrice * 100));

        priceContainer.innerHTML = '';

        if (Value == 1) {
          // Handle quantity = 1
          if (isFirstItemDiscountApplicable) {
            // 1st item discount configured, so the product price becomes the struck-through was-price
            priceContainer.innerHTML = `
              <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
              <s class="price-item price-item--compare price-item--regular">${formatPrice(regularPrice)}</s>
            `;
          } else if (compareAtPrice && compareAtPrice > regularPrice) {
            priceContainer.innerHTML = `
              <span class="price-item price-item--sale price-item--last">${formatPrice(regularPrice)}</span>
              <s class="price-item price-item--compare price-item--regular">${formatPrice(compareAtPrice)}</s>
            `;
          } else {
            priceContainer.innerHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(regularPrice)}</span>
              </div>
            `;
          }
        } else if (Value > 1 && totalCompareAtPrice) {
          // Show compare-at and regular for quantity > 1
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--compare price-item--regular">${formatPrice(totalCompareAtPrice)}</s>
          `;
        } else if (finalPrice < totalRegularPrice) {
          // Discounted without compare-at
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</s>
          `;
        } else {
          // No discount or compare-at
          priceContainer.innerHTML = `
            <div class="price__regular">
              <span class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</span>
            </div>
          `;
        }

        updatePerServingPrice(priceContainer, finalPrice, Value);

        // Update comfort points based on discounted or regular price
        updateCustomerPoints(Value, totalRegularPrice, finalPrice);
      });
    }
};

// Per-unit line under the main price (price-per-serving.liquid). It sits outside
// .price__container, which the block above rewrites wholesale, so it is re-worked here off the
// same final price. Scoped to the price block it belongs to, so the bulk tiles' own per-unit
// lines — fixed pack sizes, already correct — are left alone.
function updatePerServingPrice(priceContainer, finalPrice, quantity) {
    const line = priceContainer.closest('.price')?.parentElement?.querySelector(':scope > [data-price-per-serving]');
    if (!line) return;

    const servings = Number(line.getAttribute('data-servings')) || 0;
    const totalServings = servings * (Number(quantity) || 1);
    if (totalServings <= 0) return;

    // Truncated to the penny, the same integer divide price-per-serving.liquid does, so the line
    // never lands a penny away from the matching bulk tile.
    const perServing = Math.floor(Math.round(finalPrice * 100) / totalServings) / 100;
    const unit = line.getAttribute('data-serving-unit') || '';
    (line.querySelector('span') || line).textContent = `${formatPrice(perServing)} / ${unit}`;
}

function formatPrice(price) {
    // Ensure two decimals, then swap . and ,
    let parts = price.toFixed(2).split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1];
    // Add thousands separator (.)
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // Join with comma as decimal separator
    return `£${integerPart}.${decimalPart}`;
}

function getProductPriceBasedOnQuantity(Value, unitPrice) {
    return unitPrice * Value;
}

// Multipack price for `qty` bottles, rounded exactly like bulk-buy.liquid and price.liquid, which is what the cart
// charges: the discount comes off EACH bottle in whole pence rounded down, then that bottle price is multiplied by
// the quantity (2 x £14.49 at 10% off is £26.10, not the £26.08 a discount off the total gives). unitPrice and the
// return are pounds; percent is a whole number such as 10. The small epsilon stops float noise (99.99999...) from
// flooring a whole penny away.
function applyUnitPennyDiscount(unitPrice, qty, percent) {
    const unitPence = Math.round(unitPrice * 100);
    const discountPence = percent ? Math.floor((unitPence * percent) / 100 + 1e-6) : 0;
    return ((unitPence - discountPence) * qty) / 100;
}

function updateCustomerPoints(Value, totalRegularPrice, finalPrice) {
  const customerPointsElement = document.getElementById('comfortPoints');
  // Use the discounted price if there is a discount, else use the regular price
  let priceToUse = (finalPrice < totalRegularPrice) ? finalPrice : totalRegularPrice;
  let updatedPrice = priceToUse; // Convert from cents to euros
  const ceilCustomerPoints = Math.floor(updatedPrice);
  if (customerPointsElement) {
      customerPointsElement.innerText = `${ceilCustomerPoints}`;
  }
}

// Function to update comfort points based on bulk buy //
  const customerPointsElement = document.getElementById('comfortPoints');
  const bulkBuyInputs = document.querySelectorAll('.bulkbuy-input-element');
  if(bulkBuyInputs){
    bulkBuyInputs.forEach(input => {
      input.addEventListener('change', function() {
        const points = this.getAttribute('data-points');
        if (customerPointsElement) {
          customerPointsElement.innerText = `${points}`;
        }
      });
    });
  }
  rebindBulkBuyEvents();


/***variant Updation code */
let lastUrl = location.href;
function highlightVariantImage() {
  const variantSelects = document.querySelector("variant-selects, .variant-selects");
  if (!variantSelects) return;

  const checkedInput = variantSelects.querySelector("input[type='radio']:checked");
  if (!checkedInput) return;

  const selectedValue = checkedInput.value.trim();
  if (!selectedValue) return;

  // Remove old highlights
  document.querySelectorAll(".variant-image-found").forEach(el =>
    el.classList.remove("variant-image-found")
  );

  // Highlight elements directly matching via data attributes
  const matchingElements = document.querySelectorAll("[data-variant-thumbnail-alt], [data-media-variant]");
  matchingElements.forEach(el => {
    const alt = el.getAttribute("data-variant-thumbnail-alt") || "";
    const media = el.getAttribute("data-media-variant") || "";
    if (alt.includes(selectedValue) || media.includes(selectedValue)) {
      el.classList.add("variant-image-found");
    }
  });

  // Highlight closest .owl-item for each .media_modal_wrapper
  document.querySelectorAll(".media_modal_wrapper").forEach(wrapper => {
    const variantAlt = wrapper.getAttribute("data-variant-thumbnail-alt") || "";
    const owlItem = wrapper.closest(".owl-item");

    if (!owlItem) return;

    if (variantAlt.includes(selectedValue)) {
      owlItem.classList.add("variant-image-found");
    } else {
      owlItem.classList.remove("variant-image-found");
    }
  });
}

// NOTE: Media (main slider + thumbnail slider + modal) is now rebuilt together
// from a single fetch inside product-info.js `updateMedia()` on variant change.
// This function used to do a SECOND fetch + wrapper replacement, which ran after
// the native update and caused the media to blink/rebuild twice. It is kept as a
// no-op so any remaining callers (e.g. the minified global.min.js change handler)
// do nothing instead of triggering that duplicate rebuild.
window.refreshScrollingAt = function () {
  /* intentionally left blank – see note above */
};


// Toggle visibility of bulk-buy options based on selected variant
function toggleBulkBuyVisibilityAndSelectFirst(e, targetID) {
  const el = e?.target || e;
  if (!el || !(el instanceof Element)) return;

  // Only respond to checked input
  if (el.tagName === 'INPUT' && !el.checked) return;

  const checkedInputvariantId = targetID;
  const wrapper = el.closest('.product__info-wrapper') || document;

  let firstVisibleBulkBuy = null;

  wrapper.querySelectorAll('.bulk-buy-inner').forEach(inner => {
    const bulkBuyVariantId = inner.getAttribute('data-variant-bulk-id')?.trim();

    if (checkedInputvariantId === bulkBuyVariantId) {
      inner.classList.remove("hidden");
      if (!firstVisibleBulkBuy) firstVisibleBulkBuy = inner;
    } else {
      inner.classList.add("hidden");
    }
  });

  // Select the first input inside the first visible bulk-buy-inner
  if (firstVisibleBulkBuy) {
    // Don't clobber an existing selection (e.g. restored from ?qty=); a newly
    // revealed block has nothing checked, so it still falls through to the first.
    const firstInput =
      firstVisibleBulkBuy.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked') ||
      firstVisibleBulkBuy.querySelector('input[type="radio"], input[type="checkbox"]');
    if (firstInput) {
      firstInput.checked = true;
      // Optionally, trigger change event if your logic depends on it
      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  highlightVariantImage();
  //refreshScrollingAtc();
  rebindBulkBuyEvents();
}

// Auto-run on page load
// Trigger bulk-buy visibility if variant is pre-selected
const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
if (checkedInput) {
  const variantId = checkedInput.getAttribute('product-option-variant-id');
  toggleBulkBuyVisibilityAndSelectFirst(checkedInput, variantId);
}

// Run other variant-related logic
if (
  location.href.includes('/products/') &&
  document.body.classList.contains('body-has-variants')
) {
  window.runVariantUpdateLogic?.();
}

setTimeout(() => {
  rebindBulkBuyEvents();
}, 300);

// Scoped to product pages: re-run variant logic on URL change; this file also loads on collection pages where a body-wide subtree observer firing on every DOM mutation was needless main-thread work.
if (location.pathname.includes('/products/')) {
  const observer = new MutationObserver(() => {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      window.runVariantUpdateLogic?.();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Product Reviews 
const reviewElement = document.querySelectorAll('#goAllReviews');

reviewElement?.forEach((each) => {
  each.addEventListener('click', (event) => {
    event.preventDefault();
    const reviewHref = each.getAttribute('href');
    const reviewWrapper = document.querySelector(reviewHref);  
    if (reviewWrapper) {
      smoothScrollToElement(reviewWrapper, 160)
    }
  });
})

function smoothScrollToElement(element, offset = 0) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  const scrollPosition = absoluteElementTop - offset;
  
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
}

// Mega sale
document.querySelectorAll('.mega-sale-copy-button').forEach(function (button) {
  button.addEventListener('click', function () {
    const discountCode = this.dataset.discountCode;
    const tooltip = this.querySelector('.tooltiptext');

    if (!discountCode) return;

    // Copy to clipboard
    navigator.clipboard.writeText(discountCode).then(() => {
      // Show tooltip
      tooltip.classList.add('active');

      // Hide tooltip after 2 seconds
      setTimeout(() => {
        tooltip.classList.remove('active');
      }, 2000);
    });
  });

});
// Know More / close, per box: a page can show more than one Grab at box (several campaign offers), and each
// box's markup repeats the same ids, so the handler works from the box that was clicked rather than by id.
document.addEventListener('click', function (event) {
  const knowMore = event.target.closest('.mega-sale__offer_box .know-more');
  const close = event.target.closest('.mega-sale__offer_box .mega-sale-close-button');
  const trigger = knowMore || close;
  if (!trigger) return;

  const box = trigger.closest('.mega-sale__offer_box');
  const summary = box.querySelector('.offer-box__container');
  const details = box.querySelector('.offer-content__box');
  if (summary) summary.classList.toggle('hidden', !!knowMore);
  if (details) details.classList.toggle('hidden', !knowMore);
});

// The multipack in play for the variant on screen, or null when there is none to price against. xvd traffic gets no
// multipack discount: the tiles are display:none for it, but that class only lands on DOMContentLoaded, so the
// sessionStorage flag theme.liquid sets is checked too — the same signal product-form.js and bulk-buy-qty.js use.
function getVisibleMultipack() {
  const wrapper = document.querySelector('.main-bulk-buy');
  if (!wrapper) return null;

  let xvdStored = null;
  try {
    xvdStored = sessionStorage.getItem('xvd_found');
  } catch (e) {}
  if (xvdStored === 'true') return null;

  // ":visible" test — catches display:none on the wrapper or any ancestor.
  if (!(wrapper.offsetWidth || wrapper.offsetHeight || wrapper.getClientRects().length)) return null;

  const shownInner = Array.prototype.find.call(
    wrapper.querySelectorAll('.bulk-buy-inner'),
    (inner) => !inner.classList.contains('hidden')
  );
  if (!shownInner) return null;

  const labels = Array.prototype.slice.call(shownInner.querySelectorAll('label.bulk-buy[data-qty]'));
  if (!labels.length) return null;

  return { wrapper: wrapper, labels: labels };
}

// Discount % for a pack size, straight from Theme settings > Multiple Quantity Discount as printed on the tile
// wrapper. Anything past the 3rd tile (quantity 4+ from the sticky bar) sits on the 3rd item discount, the same
// tier updatePriceDisplay applies to the main price.
function getPackDiscountPercent(wrapper, qty) {
  const attribute = qty <= 1 ? 'data-discount-one' : qty === 2 ? 'data-discount-two' : 'data-discount-three';
  return Number(wrapper.getAttribute(attribute)) || 0;
}

// Pack price in pence, plus the % behind it, for `qty` on a bulk-buy product — null when the page has no multipack.
// 1-3 come straight off the tile, so the Grab at price is the identical figure the selected tile shows; past the
// last tile the price is recalculated from the same settings the tiles were built from.
function getPackPrice(qty) {
  const multipack = getVisibleMultipack();
  if (!multipack) return null;

  const percent = getPackDiscountPercent(multipack.wrapper, qty);

  const matching = Array.prototype.find.call(
    multipack.labels,
    (label) => Number(label.getAttribute('data-qty')) === qty
  );
  if (matching) {
    const input = matching.querySelector('input[name="bulk_buy_qty"]');
    const discounted = input ? parseInt(input.getAttribute('data-bulk-buy-discounted-price'), 10) : NaN;
    const original = input ? parseInt(input.getAttribute('data-bulk-buy-price'), 10) : NaN;
    if (!isNaN(discounted) && !isNaN(original)) {
      return { original: original, discounted: discounted, percent: percent };
    }
  }

  const unitInput = multipack.labels[0].querySelector('input[name="bulk_buy_qty"]');
  const unitPrice = unitInput ? parseInt(unitInput.getAttribute('data-bulk-buy-price'), 10) : NaN;
  if (isNaN(unitPrice)) return null;

  const original = unitPrice * qty;
  return {
    original: original,
    discounted: Math.round(applyUnitPennyDiscount(unitPrice / 100, qty, percent) * 100),
    percent: percent
  };
}

// Re-renders the offer copy for the selected pack: the % the box was rendered with (data-offer-percentage) is
// swapped for the pack's own discount everywhere it appears, so the code and badge match the price above them —
// 1 pack FLAT50 / EXTRA 50% Off, 2 pack FLAT53 / EXTRA 53% Off, 3 pack FLAT60 / EXTRA 60% Off. Always substitutes
// from the data-offer-* strings rather than what is on screen, so switching packs any number of times is exact.
function applyPackOfferCopy(megaSaleBox, packPercent) {
  const basePercent = megaSaleBox.getAttribute('data-offer-percentage');
  if (!basePercent || !/^\d+$/.test(basePercent) || !packPercent) return;

  // Matches the % as a whole number only, so a single digit percentage can't rewrite digits inside other numbers
  // ("5" leaves the 50 in "£50" alone). Written without a lookbehind, which older iOS Safari doesn't support, and
  // replaced through a function because a '$1' + 53 replacement string would read as capture group 153.
  const percentPattern = new RegExp('(^|\\D)' + basePercent + '(?!\\d)', 'g');
  const swapPercent = (text) =>
    (text || '').replace(percentPattern, (match, before) => before + packPercent);
  const setHtml = (selector, html) => {
    megaSaleBox.querySelectorAll(selector).forEach((element) => (element.innerHTML = html));
  };

  const offerCode = swapPercent(megaSaleBox.getAttribute('data-offer-code'));
  setHtml('.mega-sale-badge-text', swapPercent(megaSaleBox.getAttribute('data-offer-badge')));
  setHtml('.bottom-description', swapPercent(megaSaleBox.getAttribute('data-offer-description')));
  setHtml('.tag-1-description', swapPercent(megaSaleBox.getAttribute('data-offer-content')));
  setHtml('#mega-menu-coupon-code-text', offerCode);
  // Keeps the copy-to-clipboard button handing over the code that is now on screen.
  megaSaleBox
    .querySelectorAll('.mega-sale-copy-button')
    .forEach((button) => button.setAttribute('data-discount-code', offerCode));
}

// Re-prices EVERY Grab at box on the page for `value` (a page can show several campaign offers). The WeightWorld
// points line follows the first visible box — the best offer, since campaign boxes are rendered highest % first.
window.updateMegaSalePrice = function(value) {
  const megaSaleBoxes = Array.prototype.slice.call(document.querySelectorAll('.mega-sale__offer_box'));
  if (!megaSaleBoxes.length) return;

  const quantity = parseInt(value, 10);
  if (isNaN(quantity) || quantity <= 0) return;

  // Bulk-buy products price the offer off the selected multipack (theme settings > Multiple Quantity Discount),
  // so Grab at always matches the pack the customer picked. Everything else keeps the offer % off price x qty —
  // including a pack whose discount is set to 0, which has no pack price of its own to show.
  const packPrice = getPackPrice(quantity);
  const pack = packPrice && packPrice.percent > 0 ? packPrice : null;

  let pointsSet = false;
  megaSaleBoxes.forEach(function (megaSaleBox) {
    const megaSalePrice = parseInt(megaSaleBox.getAttribute('data-discounted-price'));
    const originalPrice = parseInt(megaSaleBox.getAttribute('data-original-price'));
    const megaSalePriceElement = megaSaleBox.querySelectorAll('.mega-sale-price');
    const megaSaleSavePriceElement = megaSaleBox.querySelector('.mega-sale-extra-saving-price');

    const totalOriginalPrice = pack ? pack.original / 100 : (originalPrice * quantity) / 100;
    const discountedPrice = pack ? pack.discounted / 100 : (megaSalePrice * quantity) / 100;

    const finalSavedAmount = formatPrice(totalOriginalPrice - discountedPrice);
    const finalDiscountedPrice = formatPrice(discountedPrice);
    megaSalePriceElement.forEach((each) => (each.textContent = finalDiscountedPrice));
    if (megaSaleSavePriceElement) megaSaleSavePriceElement.textContent = finalSavedAmount;

    // Code and badge follow the pack too. Without a multipack the copy stays exactly as configured.
    if (pack) applyPackOfferCopy(megaSaleBox, pack.percent);

    // Points follow the Grab at price while a box is on the product — it is what the customer pays. Runs after
    // updatePriceDisplay and after the pack's own data-points, both of which price off the plain/pack price, so
    // this is the last write. Only the first VISIBLE box sets them (hidden customizer boxes are skipped).
    const isVisible = !!(megaSaleBox.offsetWidth || megaSaleBox.offsetHeight || megaSaleBox.getClientRects().length);
    if (!pointsSet && isVisible) {
      pointsSet = true;
      const comfortPointsElement = document.getElementById('comfortPoints');
      if (comfortPointsElement) comfortPointsElement.innerText = `${Math.floor(discountedPrice)}`;
    }
  });
}

document.querySelectorAll('[id^="BuyNowButton-"]').forEach(button => {
  button.addEventListener("click", async function () {
    const productForm = button.closest('product-form');
    const form = productForm.querySelector('form');

    if (!form) return;

    button.setAttribute('disabled', true);

    // Suppress the cart drawer from opening while we're heading straight to checkout.
    // The freebie logic below still adds/removes gift line items, but its drawer
    // re-render (refreshCartDrawer -> renderContents -> open()) would otherwise flash
    // the drawer open for a moment before the redirect fires. See refreshCartDrawer.
    window._suppressCartDrawerOpen = true;

    const formData = new FormData(form);

    // The selling_plan input in <subscription-options> is bound to the main form by id only,
    // so the sticky bar's form never carries it. Decide it here, as product-form.js does on submit.
    formData.delete('selling_plan');
    const subscriptionOptions = productForm.subscriptionOptionsFor?.(String(formData.get('id') || ''));
    if (subscriptionOptions) {
      const checked = subscriptionOptions.querySelector('input[name="purchase_type"]:checked');
      const sellingPlanId = subscriptionOptions.querySelector('.po-selling-plan')?.value || '';
      if (checked?.value === 'subscription' && sellingPlanId) {
        formData.set('selling_plan', sellingPlanId);
      }
    }

    try {
      // Add product to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      // Get updated cart
      const cartResponse = await fetch('/cart.js');
      const cartState = await cartResponse.json();

      // Run the freebie logic if it's available (cart.js is only loaded for the drawer
      // cart type, so guard the call — otherwise Buy Now throws and never reaches checkout).
      if (typeof window.handleGiftProduct === 'function') {
        await window.handleGiftProduct(cartState);
      }

      // Same for the free bundle, so Buy Now grants it exactly like adding to the cart does.
      // Called with no argument on purpose: handleGiftProduct above may have just added or
      // removed a gift line, and the bundle threshold counts those, so it needs to read a
      // fresh cart rather than the stale cartState fetched before that ran.
      if (typeof window.syncCartDrawerBundle === 'function') {
        await window.syncCartDrawerBundle(null, true);
      }

      // Redirect after gift logic completes
      window.location.href = '/checkout';

      setTimeout(() => {
        button.removeAttribute('disabled');
      }, 500);

    } catch (err) {
      console.error('Buy Now error:', err);
      window._suppressCartDrawerOpen = false;
      button.removeAttribute('disabled');
    }
  });
});

// Multipack <-> ?qty= sync. The param is only written while the tiles are visible.
(function () {
  const QTY_PARAM = 'qty';
  const PACK_INPUT = 'input[name="bulk_buy_qty"]';

  // ":visible" test — catches display:none on the element or any ancestor.
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  // Tiles of the shown variant block, or [] when the multipack isn't on screen.
  function getPackLabels() {
    if (location.pathname.indexOf('/products/') === -1) return [];

    const wrapper = document.querySelector('.main-bulk-buy');
    if (!isVisible(wrapper)) return [];

    const shownInner = Array.prototype.find.call(
      wrapper.querySelectorAll('.bulk-buy-inner'),
      (inner) => !inner.classList.contains('hidden')
    );
    if (!shownInner) return [];

    return Array.prototype.slice.call(shownInner.querySelectorAll('label.bulk-buy[data-qty]'));
  }

  function findLabel(labels, qty) {
    return Array.prototype.find.call(labels, (label) => label.getAttribute('data-qty') === String(qty));
  }

  function writeQtyToUrl(qty) {
    const url = new URL(window.location.href);
    if (url.searchParams.get(QTY_PARAM) === String(qty)) return;
    url.searchParams.set(QTY_PARAM, qty);
    // replaceState, not pushState: switching packs shouldn't stack up history entries.
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function applyQtyFromUrl() {
    const labels = getPackLabels();
    if (!labels.length) return; // No multipack on screen -> leave the URL alone.

    const requested = new URLSearchParams(window.location.search).get(QTY_PARAM);
    // Anything that isn't a rendered tile (0, 5, "abc", missing) falls back to 1 pack.
    const target = findLabel(labels, requested) || findLabel(labels, 1) || labels[0];
    const qty = target.getAttribute('data-qty');

    const input = target.querySelector(PACK_INPUT);
    if (input && !input.checked) {
      target.click(); // real click, so every existing listener stays in the loop
    } else if (input && qty !== '1') {
      // bulk-buy-qty.js already ticked it; the rest of the page is still priced for 1 pack.
      input.dispatchEvent(new Event('change', { bubbles: true })); // loyalty points
      if (typeof window.updatePriceDisplay === 'function') window.updatePriceDisplay(qty);
    }

    // Always, including the default 1 pack: the Grab at box is rendered from the offer % off a single unit, and on a
    // bulk-buy product the pack discount from theme settings is what decides that price instead.
    if (typeof window.updateMegaSalePrice === 'function') window.updateMegaSalePrice(qty);

    writeQtyToUrl(qty);
  }

  // Every pack change — click or programmatic — mirrored back into the URL.
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || typeof input.matches !== 'function' || !input.matches(PACK_INPUT) || !input.checked) return;

    const label = input.closest('label.bulk-buy[data-qty]');
    if (!label || !getPackLabels().length) return;

    writeQtyToUrl(label.getAttribute('data-qty'));
  });

  let applied = false;
  function runOnce() {
    if (applied) return;
    applied = true;
    applyQtyFromUrl();
  }

  // DOMContentLoaded so body.found_xvd_permeter is applied first; timeout is the fallback.
  document.addEventListener('DOMContentLoaded', runOnce);
  setTimeout(runOnce, 0);
})();

// Customer related Slider
const slider = document.querySelector(".customer-related-slider");

if (slider) {
  $(slider).owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 1300,

    // Blink / Fade Effect
    animateOut: "fadeOut",
    animateIn: "fadeIn",

    smartSpeed: 500,
    mouseDrag: false,
    touchDrag: false
  });
}
